import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Flex.scss";

export const Flex = forwardRef(
  (
    {
      children,
      width,
      height,
      margin,
      padding,
      justifyContent,
      flexDirection,
      flexGrow,
      flexBasis,
      flexShrink,
      flex,
      alignItems,
      container,
      wrap,
      customClass,
      gap,
      ...otherStyles
    },
    ref
  ) => {
    const flexStyles = {
      width,
      height,
      margin,
      padding,
      justifyContent,
      flexDirection,
      flex,
      flexGrow,
      flexBasis,
      flexShrink,
      flexWrap: wrap ? "wrap" : "nowrap",
      alignItems,
      ...otherStyles,
    };

    const classes = classNames(styles.flex, {
      [styles.container]: container,
      [customClass]: customClass,
      [styles.gap]: gap,
    });
    return (
      <div ref={ref} style={flexStyles} className={classes}>
        {children}
      </div>
    );
  }
);

Flex.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  customClass: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  justifyContent: PropTypes.string,
  flexDirection: PropTypes.string,
  flexGrow: PropTypes.string,
  flexBasis: PropTypes.string,
  flexShrink: PropTypes.string,
  flex: PropTypes.string,
  alignItems: PropTypes.string,
  container: PropTypes.bool,
  wrap: PropTypes.bool,
  gap: PropTypes.bool,
};

Flex.defaultProps = {
  customClass: null,
  children: null,
  width: null,
  height: null,
  margin: null,
  padding: null,
  justifyContent: null,
  flexDirection: null,
  flexGrow: null,
  flexBasis: null,
  flexShrink: null,
  flex: null,
  alignItems: null,
  container: false,
  wrap: false,
  gap: false,
};

Flex.displayName = "Flex";

export default Flex;
